const SharedTextContent = ({ isHighlightVideo }) => (
    <>
        <h3 className="heading heading--small">
            {isHighlightVideo
                ? 'Bekijk de samenvatting in de app'
                : 'Bekijk de goal in de app'}
        </h3>
        <p className="text">
            {isHighlightVideo ? (
                // It must be double quote in case of ' sign inside
                // eslint-disable-next-line quotes
                "Kijk naast de samenvatting ook gratis andere video's van je favoriete club(s) direct op je telefoon!"
            ) : (
                <>
                    Maak een{' '}
                    <span className="text--red text--bold">gratis</span> account
                    en krijg goals van je favoriete club(s) binnen no-time op je
                    telefoon!
                </>
            )}
        </p>
    </>
);

export default SharedTextContent;
